import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true })

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const fetchItemsAutocomplete = (search) => API.get(`item/${search}/search`);
export const getItem = (itemId, userId, logObject) => API.get(`item/${itemId}/${userId}/${logObject}/get`);
export const getItemFeed = (userId, filters, page) => API.get(`item/${userId}/${filters}/${page}/items`)
export const getCategoryFeed = (userId, itemId, filters, page) => API.get(`item/${userId}/${itemId}/${filters}/${page}/category`)
export const submitItem = (formData, sessionId) => API.post('/item', {...formData, sessionId})
export const triggerItem = (userId, datumId, value, triggerType, itemId, triggerID, sessionId) => API.put('/item/trigger', { userId: userId, datumId: datumId, value: value, itemId: itemId, triggerType: triggerType, triggerId: triggerID, sessionId: sessionId })
export const fetch_theme = () => API.get('item/fetch_theme');

//get ref and relations
export const getref_rel = async (ref, themes) => {
    const res = await API.post(`item/get_ref_rel`, { ref: ref, themes: themes })
    return res;
}
